import { render, staticRenderFns } from "./electricitySafety.vue?vue&type=template&id=58860c45&scoped=true"
import script from "./electricitySafety.vue?vue&type=script&lang=js"
export * from "./electricitySafety.vue?vue&type=script&lang=js"
import style0 from "./electricitySafety.vue?vue&type=style&index=0&id=58860c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58860c45",
  null
  
)

export default component.exports